import { z } from 'zod';

export const WORK_ORDER_LIST_OPTIONS = [
  { label: 'Process Service Work List', value: 'PROCESS_SERVICE' },
  { label: 'Home Inspection Work Order List', value: 'HOME_INSPECTION' },
  { label: 'Due Diligence Work Order List', value: 'DUE_DILIGENCE' },
] as const;

export const rushPrioritySettingSchema = z
  .object({
    showRushOnTop: z.boolean(),
    lists: z.array(z.enum(['PROCESS_SERVICE', 'HOME_INSPECTION', 'DUE_DILIGENCE'])),
  })
  .refine((values) => !values.showRushOnTop || values.lists.length > 0, {
    message: 'Select at least one work order list',
    path: ['lists'],
  });

export type RushPrioritySettingFormValues = z.infer<typeof rushPrioritySettingSchema>;
